import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Message } from 'src/app/model/message';
import { AlertDialogComponent } from 'src/app/store/dialogs/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export class MessageService {
    public message;
    public messageAdded$ : BehaviorSubject<Message>;

    constructor(private dialog: MatDialog) {
        this.messageAdded$ = new BehaviorSubject<Message>(this.message);
     }

    public setMessage(title: string, text: string) {
        this.message = new Message();
        this.message.Title = title;
        this.message.MessageText = text;
        this.messageAdded$.next(this.message);
    }
}
